import { MemberPostList } from './MemberPostList'
import { SpacePostList } from './SpacePostList'

export const PostList = ({
  memberId,
  spaceId,
  tagId,
  hasParent = false,
}: {
  memberId?: string
  spaceId?: string
  tagId?: string
  hasParent?: boolean
}) => {
  if (spaceId) return <SpacePostList spaceId={spaceId} tagId={tagId} />
  return <MemberPostList hasParent={hasParent} memberId={memberId} />
}
